export default __webpack_public_path__ + "static/char-v-sp01-d71802a75689b04f8d9d76c52bd71f08.png";